import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "roles-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_SchemaImage = _resolveComponent("SchemaImage")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('wiki.rolesTitle')), 1),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('wiki.rolesInfo')), 1),
    _createElementVNode("nav", {
      class: "wiki-nav",
      "aria-label": _ctx.$t('wiki.title')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.rules')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.roles')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'expansions' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.addons')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'merlin' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.merlin')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "merlin",
            src: _ctx.calculateRoleUrl('merlin'),
            alt: _ctx.$t('roles.merlin'),
            description: _ctx.$t('roles.merlin')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'merlin_pure' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.merlinPure')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "merlinPure",
            src: _ctx.calculateRoleUrl('merlinPure'),
            alt: _ctx.$t('roles.merlinPure'),
            description: _ctx.$t('roles.merlinPure')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'guinevere' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.guinevere')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "guinevere",
            src: _ctx.calculateRoleUrl('guinevere'),
            alt: _ctx.$t('roles.guinevere'),
            description: _ctx.$t('roles.guinevere')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'percival' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.percival')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "percival",
            src: _ctx.calculateRoleUrl('percival'),
            alt: _ctx.$t('roles.percival'),
            description: _ctx.$t('roles.percival')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'lovers' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.tristan')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "tristan",
            src: _ctx.calculateRoleUrl('tristan'),
            alt: _ctx.$t('roles.tristan'),
            description: _ctx.$t('roles.tristan')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'lovers' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.isolde')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "isolde",
            src: _ctx.calculateRoleUrl('isolde'),
            alt: _ctx.$t('roles.isolde'),
            description: _ctx.$t('roles.isolde')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'cleric' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.cleric')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "cleric",
            src: _ctx.calculateRoleUrl('cleric'),
            alt: _ctx.$t('roles.cleric'),
            description: _ctx.$t('roles.cleric')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'troublemaker' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.troublemaker')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "troublemaker",
            src: _ctx.calculateRoleUrl('troublemaker'),
            alt: _ctx.$t('roles.troublemaker'),
            description: _ctx.$t('roles.troublemaker')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'servant' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.servant')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "servant",
            src: _ctx.calculateRoleUrl('servant'),
            alt: _ctx.$t('roles.servant'),
            description: _ctx.$t('roles.servant')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'lancelots' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.goodLancelot')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image",
            role: "goodLancelot",
            src: _ctx.calculateRoleUrl('goodLancelot'),
            alt: _ctx.$t('roles.goodLancelot'),
            description: _ctx.$t('roles.goodLancelot')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'lancelots' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.evilLancelot')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "evilLancelot",
            src: _ctx.calculateRoleUrl('evilLancelot'),
            alt: _ctx.$t('roles.evilLancelot'),
            description: _ctx.$t('roles.evilLancelot')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'mordred' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.mordred')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "mordred",
            src: _ctx.calculateRoleUrl('mordred'),
            alt: _ctx.$t('roles.mordred'),
            description: _ctx.$t('roles.mordred')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'morgana' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.morgana')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "morgana",
            src: _ctx.calculateRoleUrl('morgana'),
            alt: _ctx.$t('roles.morgana'),
            description: _ctx.$t('roles.morgana')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'oberon' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.oberon')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "oberon",
            src: _ctx.calculateRoleUrl('oberon'),
            alt: _ctx.$t('roles.oberon'),
            description: _ctx.$t('roles.oberon')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'trickster' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.trickster')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "trickster",
            src: _ctx.calculateRoleUrl('trickster'),
            alt: _ctx.$t('roles.trickster'),
            description: _ctx.$t('roles.trickster')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'witch' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.witch')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "witch",
            src: _ctx.calculateRoleUrl('witch'),
            alt: _ctx.$t('roles.witch'),
            description: _ctx.$t('roles.witch')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'revealer' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.revealer')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "revealer",
            src: _ctx.calculateRoleUrl('revealer'),
            alt: _ctx.$t('roles.revealer'),
            description: _ctx.$t('roles.revealer')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'lunatic' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.lunatic')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "lunatic",
            src: _ctx.calculateRoleUrl('lunatic'),
            alt: _ctx.$t('roles.lunatic'),
            description: _ctx.$t('roles.lunatic')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'brute' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.brute')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "brute",
            src: _ctx.calculateRoleUrl('brute'),
            alt: _ctx.$t('roles.brute'),
            description: _ctx.$t('roles.brute')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "role",
        to: { name: 'minion' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('roles.minion')), 1),
          _createVNode(_component_SchemaImage, {
            class: "role-image evil-role",
            role: "minion",
            src: _ctx.calculateRoleUrl('minion'),
            alt: _ctx.$t('roles.minion'),
            description: _ctx.$t('roles.minion')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}